import { Body, Injectable, Req } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Raw, Repository } from 'typeorm';
import { ContactModelDefault, ErrorResponse } from '@gtpl/shared-models/common-models';
import { RmRack } from './rm-racks.entity';
import { AllRacksResponseModel, AllRmRacksResponseModel, CommonResponse, RackDetails, RackDropDownDto, RackDropDownResponseModel, RackResponseModel, RacksForZoneId, RmRackDetails, RmRackDropDownDto, RmRackDropDownResponseModel, RmRackResponseModel, RmZonesIdRequest } from '@gtpl/shared-models/masters';
import { ZoneByIdDto } from './dto/zone-id-request-dto';
import { PlantIdRequest } from '@gtpl/shared-models/warehouse-management';
import appSettings from 'apps/services/config';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { RmRackAdapter } from './dto/rm-racks.adapter';
import { RmRackDTO } from './dto/rm-racks.dto';
import { RmRackRequest } from './dto/rm-racks.request';
import { RmRackIdRequest } from './dto/rm-rackId.request';
import { RmRackRepository } from './dto/rm-rack-repository';



@Injectable()
export class RmRacksService {
    constructor(
        @InjectRepository(RmRack) private rackRepository: Repository<RmRack>,
        private rackAdapter: RmRackAdapter,
    ) { }

    async getRmRackWithoutRelations(zoneId: number, rmRackName: string): Promise<RmRack> {
        console.log(zoneId, rmRackName);
        const response = await this.rackRepository.findOne({
            where: { zoneId: Raw(alias => `zone_id = '${zoneId}'`), rmRackName: Raw(alias => `rm_rack_name = '${rmRackName}'`) },
        });
        console.log(response);
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async createRmRack(rackDto: RmRackDTO, isUpdate: boolean = false, @Req() request: Request): Promise<RmRackResponseModel> {
        try {
            console.log('rackDto' + rackDto);
            console.log('rackDto' + isUpdate);
            if (!isUpdate) {
                const rackEntity = await this.getRmRackWithoutRelations(rackDto.zoneId, rackDto.rmRackName);
                if (rackEntity) {
                    throw new RackResponseModel(false, 11104, 'Rack already exists');
                }
            } else {
                const rackEntity = await this.getRmRackWithoutRelationsForUpdate(rackDto.rmRackCode, rackDto.rmRackName, rackDto.rmRackId, rackDto.zoneId, rackDto.plantId);
                if (rackEntity) {
                    console.log(rackEntity);
                    console.log(rackEntity.rmRackId + "*" + rackDto.rmRackId)
                    if (rackEntity.rmRackId != rackDto.rmRackId) {
                        throw new RackResponseModel(false, 11104, 'Rack already exists');
                    }
                }
            }
            const rackEntity: RmRack = this.rackAdapter.convertDtoToEntity(rackDto, isUpdate);
            const savedRackEntity: RmRack = await this.rackRepository.save(rackEntity);
            const savedRackDto: RmRackDTO = this.rackAdapter.convertEntityToDto(savedRackEntity);

            if (savedRackEntity) {
                const response = new RmRackResponseModel(true, isUpdate ? 11100 : 11101, isUpdate ? 'Rack Updated Successfully' : 'Rack Created Successfully', savedRackDto);
                return response;
            } else {
                throw new RmRackResponseModel(false, 11106, 'Rack saved but issue while transforming into DTO');
            }
        }
        catch (error) {
            return error;
        }
    }

    async getAllRmRacksForPlant(plantId: PlantIdRequest): Promise<AllRmRacksResponseModel> {
        try {
            console.log(plantId);
            const racksDetails: RmRackDetails[] = [];
            // retrieves all plants
            const rackEntities: RmRack[] = await this.rackRepository.find({
                relations: ['zoneMasterInfo'],
                where: { plantId: plantId.plantId },
                order: { rmRackCode: "ASC" },
            });
            if (rackEntities.length > 0) {
                rackEntities.forEach(rackEntity => {
                    const convertedRackDto: RmRackDetails = this.rackAdapter.convertEntityDetails(rackEntity);
                    racksDetails.push(convertedRackDto);
                });
                const response = new AllRmRacksResponseModel(true, 11208, "Racks retrieved successfully", racksDetails);
                return response;
            } else {
                throw new RmRackResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getAllRmRacks(): Promise<AllRmRacksResponseModel> {
        try {
            const manager = getManager();
            const query = `SELECT u.unit_name as allocatedPlantName,zm.zone_name AS allocatedZoneName,r.allocated_plant_id AS allocatedPlantId, r.allocated_zone_id AS allocatedZoneId, SUM(IF(rp.occupancy = "Not Occupied", 1,0)) AS availCount,COUNT(rp.rm_rack_id) AS rackCount,r.rm_rack_id as rmRackMasterId, r.plant_id as unitId, r.zone_id as zoneId, r.rm_rack_name as rackName,z.zone_name as zoneName,uc.unit_name as plantName,r.is_active as isActive,r.created_user as createdUser,r.updated_user as updatedUser,r.rm_rack_code as rackCode,r.reserved_for_dummy as reservedForDummy,r.rm_rack_Type as rackPosition,r.version_flag as versionFlag FROM ` + appSettings.masters_db + `.rm_rack r 
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = r.plant_id
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = r.allocated_plant_id
            LEFT JOIN ` + appSettings.masters_db + `.rm_rack_position  rp ON rp.rm_rack_id = r.rm_rack_id
            LEFT JOIN ` + appSettings.masters_db + `.zone_master z ON z.zone_id = r.zone_Id 
            LEFT JOIN ` + appSettings.masters_db + `.zone_master zm ON zm.zone_id = r.allocated_zone_id 
            GROUP BY r.rm_rack_id ORDER BY r.plant_id, r.zone_id,r.rm_rack_name`

            const data = await manager.query(query)
            if (data.length > 0) {
                const response = new AllRmRacksResponseModel(true, 11208, "Racks retrieved successfully", data);
                return response;
            } else {
                throw new RmRackResponseModel(false, 99998, 'No Record Found');
            }
        } catch (err) {
            return err
        }

    }

    async getAllActiveRmRacks(): Promise<AllRmRacksResponseModel> {
        // const page: number = 1;
        try {
            const rackEntities: RmRackDetails[] = [];
            //retrieves all companies
            const RacksEntities: RmRack[] = await this.rackRepository.find({
                order: { 'rmRackCode': 'ASC' },
            });
            console.log(RacksEntities)
            if (RacksEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                RacksEntities.forEach(rackEntity => {
                    const rackData = new RmRackDetails(rackEntity.rmRackId, rackEntity.rmRackName, rackEntity.rmRackCode, rackEntity.reservedForDummy, rackEntity.rmZonesInfo.rmZoneId, rackEntity.rmZonesInfo.rmZoneName, rackEntity.createdUser, rackEntity.updatedUser, rackEntity.isActive, rackEntity.versionFlag, 0, 0, "", "", "");
                    rackEntities.push(rackData);
                });
                const response = new AllRmRacksResponseModel(true, 11208, "Racks retrieved successfully", rackEntities);
                return response;
            } else {
                throw new RmRackResponseModel(false, 99998, 'Data not found'); rackEntities
            }
        } catch (err) {
            throw err;
        }
    }

    async activateOrDeactivateRmRack(rackReq: RmRackRequest): Promise<RmRackResponseModel> {
        try {
            const rackExists = await this.getRmRackById(rackReq.rmRackId);
            if (rackExists) {
                if (rackReq.versionFlag !== rackExists.versionFlag) {
                    throw new RmRackResponseModel(false, 10113, 'Someone updated the current Rack information.Refresh and try again');
                } else {

                    const rackStatus = await this.rackRepository.update(
                        { rmRackId: rackReq.rmRackId },
                        { isActive: rackReq.isActive, updatedUser: rackReq.updatedUser });

                    if (rackExists.isActive) {
                        if (rackStatus.affected) {
                            const rackResponse: RmRackResponseModel = new RmRackResponseModel(true, 10115, 'Rack is de-activated successfully');
                            return rackResponse;
                        } else {
                            throw new RmRackResponseModel(false, 10111, 'Rack is already deactivated');
                        }
                    } else {
                        if (rackStatus.affected) {
                            const rackResponse: RmRackResponseModel = new RmRackResponseModel(true, 10114, 'Rack is activated successfully');
                            return rackResponse;
                        } else {
                            throw new RmRackResponseModel(false, 10112, 'Rack is already  activated');
                        }
                    }
                    // }
                }
            } else {
                throw new RackResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getRmRackById(rmRackId: number): Promise<RmRack> {
        //  console.log(employeeId);
        const Response = await this.rackRepository.findOne({
            where: { rmRackId: rmRackId },
        });
        // console.log(employeeResponse);
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    async getAllRmRackDropDown(): Promise<RmRackDropDownResponseModel> {
        try {
            const rackDto: RmRackDropDownDto[] = [];
            const rackEntities: RmRack[] = await this.rackRepository.find({ select: ['rmRackId', 'rmRackCode'], where: { isActive: true }, order: { rmRackCode: "ASC" } })


            if (rackEntities && rackEntities.length > 0) {
                rackEntities.forEach(rackEntity => {
                    rackDto.push(new RmRackDropDownDto(rackEntity.rmRackId, rackEntity.rmRackCode));
                });
                const response = new RmRackDropDownResponseModel(true, 11108, "rack retrieved successfully", rackDto);
                return response;
            } else {
                throw new RmRackResponseModel(false, 99998, 'Data not found');
            }
        } catch (err) {
            throw err;
        }
    }


    async getRmRackdataById(rackreq: RmRackRequest): Promise<RmRackDropDownDto> {
        const RackEntities = await this.rackRepository.findOne({
            select: ['rmRackId', 'rmRackCode'],
            where: { rmRackId: rackreq.rmRackId }
        });
        if (RackEntities) {
            const response = new RmRackDropDownDto(RackEntities.rmRackId, RackEntities.rmRackCode);
            return response;
        } else {
            throw new RmRackResponseModel(false, 11106, 'Something went wrong');
        }
    }

    async getRmRacksForZoneId_org(zoneIdReq: ZoneByIdDto): Promise<RmRackDropDownResponseModel> {
        try {
            const racks: RmRackDropDownDto[] = [];
            const rackEntities: RmRack[] = await this.rackRepository.find({ relations: ["rmRackPositionInfo"], where: { zoneId: zoneIdReq.zoneId, isActive: true, occupancy: 'Not Occupied' } })
            if (rackEntities && rackEntities.length > 0) {
                rackEntities.forEach(rackEntities => {
                    rackEntities.rmRackPositionInfo.forEach(rack => {
                        racks.push(new RmRackDropDownDto(rack.rmRackPositionId, rack.rmRackCode, rack.plantId));
                    })
                });
                const response = new RmRackDropDownResponseModel(true, 11108, "rack retrieved successfully", racks);
                return response;
            } else {
                throw new RmRackResponseModel(false, 99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }
    async getRmRacksForZoneId(rmZonesIdRequest: RmZonesIdRequest): Promise<RmRackDropDownResponseModel> {
        try {
            const racks: RmRackDropDownDto[] = [];
            const manager = getManager();
            const rackEntities = await manager.query(`SELECT r.rm_rack_id as rmRackId,r.rm_rack_code AS rmRackCode FROM rm_rack r WHERE r.is_active=1 AND r.zone_id=` + rmZonesIdRequest.zoneId);

            if (rackEntities && rackEntities.length > 0) {
                rackEntities.forEach(rack => {
                    racks.push(new RmRackDropDownDto(rack.rmRackId, rack.rmRackCode));
                });
                console.log(racks)
                const response = new RmRackDropDownResponseModel(true, 11108, "rack retrieved successfully", racks);
                return response;
            } else {
                throw new RmRackResponseModel(false, 99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async getRmRacksForZone(zoneIdReq: ZoneByIdDto): Promise<RmRackDropDownResponseModel> {
        try {
            const racks: RmRackDropDownDto[] = [];
            const manager = getManager();
            const rackEntities: RmRackDropDownDto[] = await manager.query(`SELECT r.rm_rack_id as rmRackId, r.rm_rack_code AS rmRackCode, r.zone_id AS zoneId, r.rm_rack_type AS rmRackType, count(rp.rm_rack_position_id) AS cnt FROM rack r left join rm_rack_position rp on rp.rm_rack_id = r.rm_rack_id WHERE r.is_active=true and rp.is_active = true AND r.zone_id=` + zoneIdReq.zoneId + ` or r.allocated_zone_id =` + zoneIdReq.zoneId + ` and rp.is_active = true group by r.rm_rack_id`);

            if (rackEntities && rackEntities.length > 0) {
                rackEntities.forEach(rack => {
                    racks.push(new RmRackDropDownDto(rack.rmRackId, rack.rmRackCode, rack.zoneId, rack.rmRackType, rack.cnt));
                });
                console.log(racks)
                const response = new RmRackDropDownResponseModel(true, 11108, "rack retrieved successfully", racks);
                return response;
            } else {
                throw new RmRackResponseModel(false, 99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }
    async getdummyRmRacksByZone(zoneIdReq: RacksForZoneId): Promise<RmRackDropDownResponseModel> {
        try {
            const racks: RmRackDropDownDto[] = [];
            const manager = getManager();
            const rackEntities = await manager.query(`SELECT r.rm_rack_id as rmRackId, r.rm_rack_name AS rmRackName FROM rm_rack r WHERE r.zone_id=` + zoneIdReq.zoneId + ` and r.reserved_for_dummy = ` + zoneIdReq.reservedForDummy);
            console.log('rackEntities');
            console.log(rackEntities.length);

            if (rackEntities && rackEntities.length > 0) {
                rackEntities.forEach(rack => {
                    racks.push(new RmRackDropDownDto(rack.rmRackId, rack.rmRackName));
                });
                console.log(racks)
                const response = new RmRackDropDownResponseModel(true, 11108, "rack retrieved successfully", racks);
                return response;
            } else {
                throw new RmRackResponseModel(false, 99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async getRmRacksForRackId(rackIdRequest: RmRackIdRequest): Promise<RmRackDropDownDto> {
        const rackId = rackIdRequest.rmRackId;
        console.log('rackId' + rackId);
        try {
            const rackEntities = await this.rackRepository.findOne({ where: { rmRackId: rackId } });
            console.log(rackEntities);
            if (rackEntities) {
                const response = new RmRackDropDownDto(rackEntities.rmRackId, rackEntities.rmRackCode, rackEntities.zoneId);
                return response;
            } else {
                throw new RmRackResponseModel(false, 99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async getRmRackWithoutRelationsForUpdate(rmRackCode: String, rmRackName: String, id: number, zoneId: number, plantId: number): Promise<RmRack> {
        const responseCode = await this.rackRepository.findOne({
            where: { rmRackCode: rmRackCode, zoneId: zoneId, rmRackId: id, plantId: plantId },
        });
        const responseNo = await this.rackRepository.findOne({
            where: { rmRackName: rmRackName, zoneId: zoneId, rmRackId: id, plantId: plantId },
        });
        if (responseCode || responseNo) {
            if (responseCode && responseNo) {
                if (responseCode.rmRackId == responseNo.rmRackId) {
                    return responseCode;
                }
                else if (responseCode.rmRackId == id) {
                    return responseNo;
                }
                else if (responseNo.rmRackId == id) {
                    return responseCode;
                }
                else {
                    return responseCode;
                }
            }
            else if (responseCode && !responseNo) {
                return responseCode;
            }
            else if (responseNo && !responseCode) {
                return responseNo;
            }
        } else {
            return null;
        }
    }
    async transferRmRack(rmRackDetails: any): Promise<CommonResponse> {
       
        const manager = new GenericTransactionManager();
        const connection = getManager();
        try {
            await manager.startTransaction();
            let updatePlantId = await manager.getCustomRepository(RmRackRepository).update({ rmRackId: Raw(alias => `rm_rack_id = (${rmRackDetails.rmRackId})`) }, { allocatedPlantId: rmRackDetails.allocatedPlantId, allocatedZoneId: rmRackDetails.allocatedZoneId });
            console.log(updatePlantId);
            if (updatePlantId.affected) {
                await manager.completeTransaction();
                return new CommonResponse(true, 1111, 'Rack Transfered Successfully');
            } else {
                await manager.releaseTransaction();
                return new CommonResponse(false, 9999, "Transfer Failed, Please Try Again")
            }
        } catch (err) {
            await manager.releaseTransaction();
            return err;
        }
    }

//     async getRacksForZoneExceptFromZone(zoneIdReq: ZoneByIdDto): Promise<RackDropDownResponseModel> {
//         try {
//             const racks: RackDropDownDto[] = [];
//             const manager = getManager();
//             const rackEntities: RackDropDownDto[] = await manager.query(`SELECT r.rack_id as rackId, r.rack_code AS rackCode, r.zone_id AS zoneId, r.rack_type AS rackType, count(rp.rack_position_id) AS cnt FROM rack r left join rack_position rp on rp.rack_id = r.rack_id WHERE r.is_active=true and rp.is_active = true AND r.zone_id=` + zoneIdReq.zoneId + ` or r.allocated_zone_id =` + zoneIdReq.zoneId + ` and rp.is_active = true group by r.rack_id`);

//             if (rackEntities && rackEntities.length > 0) {
//                 rackEntities.forEach(rack => {
//                     racks.push(new RackDropDownDto(rack.rackId, rack.rackCode, rack.zoneId, rack.rackType, rack.cnt));
//                 });
//                 console.log(racks)
//                 const response = new RackDropDownResponseModel(true, 11108, "rack retrieved successfully", racks);
//                 return response;
//             } else {
//                 throw new RackResponseModel(false, 99998, 'Data not found');
//             }
//         } catch (err) {
//             return err;
//         }
//     }


}
